
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/close",
      function () {
        return require("private-next-pages/close.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/close"])
      });
    }
  